module.exports = __webpack_public_path__ + "img/CAT.1ba05da8.png";